import React from 'react';
import {Container, GridLogoWrapper, GridLogo, GridName, GridDiscount, logoWrapperShadow} from './styles';
import {ParceiroDTO} from '../../../../../../dtos/ParceiroDTO';
import {getDestaqueImage} from '../../../../../../assets/images/clube/destaques';

interface Props {
  data: ParceiroDTO;
  discount: string;
  itemWidth: number;
  verifyAccess?: boolean;
  onClick?: () => void;
}

export function StoreGridItem({data, discount, itemWidth}: Props) {

  const logoSize = Math.floor(itemWidth * 0.75);
  const localImage = getDestaqueImage(data.nome);

  return (
    <Container style={{width: itemWidth}}>
      <GridLogoWrapper width={logoSize} height={logoSize} style={logoWrapperShadow}>
        <GridLogo
          source={localImage ?? {uri: data.imagens.logo}}
          resizeMode="contain"
          style={{width: logoSize, height: logoSize}}
        />
      </GridLogoWrapper>
      <GridName numberOfLines={1}>{data.nome.toLowerCase()}</GridName>
      <GridDiscount numberOfLines={1}>{discount}</GridDiscount>
    </Container>
  );
}
